import { render } from "./DuplicateRecordReport.vue?vue&type=template&id=1ed262ec&scoped=true"
import script from "./DuplicateRecordReport.vue?vue&type=script&lang=js"
export * from "./DuplicateRecordReport.vue?vue&type=script&lang=js"

import "./DuplicateRecordReport.vue?vue&type=style&index=0&id=1ed262ec&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed262ec"]])

export default __exports__